// extracted by mini-css-extract-plugin
export default {"screen":"Preloader_screen__HroUZ","logo":"Preloader_logo__nKSLK","loader":"Preloader_loader__quJfy","l7":"Preloader_l7__hguVt"};